"use strict";

$('a[href="#"]').click(function(e) {
  e.preventDefault();
});

$('#StockTicker').fadeIn('3000');

if ($("#StockTicker").length) {

  dayjs.extend(utc)
  dayjs.extend(timezone)

  let cachedTime = dayjs(localStorage.getItem('cachedTime'));
  let cachedData = localStorage.getItem('cachedData');
  // check if the data is cached and if the cached data is not yet a day old and current time is not yet 11AM
  if (cachedData && dayjs().diff(cachedTime, 'hours') < 24 && dayjs().hour() < 11) {
    let data = JSON.parse(cachedData);

    // Display cached data
    displayData(data);
  } else {
    fetchData();
  }
}

function fetchData() {
  $.ajax({
    type: 'GET',
    url: 'https://ir.oms.no/server/secure/components?auth=key%3d%20DOLPH&product=snapshot&',
    data: {get_param: 'value'},
    dataType: 'json',
    success: function (data) {
      // Display new data
      displayData(data);

      // Store the time of the data load and the loaded data in local storage
      localStorage.setItem('cachedTime', dayjs().toISOString());
      localStorage.setItem('cachedData', JSON.stringify(data));
    }
  });
}

function displayData(data) {
  let StockTicker__date = dayjs.tz(data['rows'][0]['values']['TIME'], "Europe/Oslo").format('DD/MM/YYYY hh:mm');
  $('.StockTicker__date').text(StockTicker__date + ' (CET)');

  let StockTicker__price = data['rows'][0]['values']['LAST'];
  $('.StockTicker__price').text(StockTicker__price);
}



// WEBPACK FOOTER //
// ./src/js/modules/_base.js